import { useDailyAppOpenEvent } from "Hooks/useDailyAppOpenEvent";

// Rendered by AuthenticatedRoute only when the user is actually in the app (all gates passed,
// not on a gate's own landing page, not anonymous) — no gate logic duplicated here.
export const DailyAppOpenTracker = () => {
  useDailyAppOpenEvent();

  return null;
};
